import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEdit2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#576063"
      fillRule="evenodd"
      d="M12.56 2.602a.833.833 0 0 0-1.12 0l-.086.085-.205.205a1.27 1.27 0 0 0 1.293 1.293l.204-.205.085-.086a.833.833 0 0 0 0-1.121l-.085-.086zm.785-.63-.112-.11a1.833 1.833 0 0 0-2.578.11l-.336.335-.013.013-4.49 4.49-.03.03c-.283.283-.466.466-.616.675a3.2 3.2 0 0 0-.337.595c-.102.236-.164.487-.261.875l-.01.04-.38 1.52a.5.5 0 0 0 .606.607l1.52-.38.04-.01c.389-.097.639-.16.876-.262q.316-.136.594-.336c.21-.151.392-.334.675-.617l4.523-4.523.008-.007.338-.338q.066-.066.109-.112c.636-.7.636-1.767 0-2.467q-.043-.046-.11-.112zm-1.75 3.06A2.29 2.29 0 0 1 10.3 3.739L6.522 7.518c-.322.322-.443.445-.54.58a2.2 2.2 0 0 0-.23.408c-.067.153-.11.32-.22.762l-.178.712.711-.178c.442-.11.61-.154.763-.22q.216-.094.407-.23c.135-.098.258-.219.58-.541zM2.165 14a.5.5 0 0 1 .5-.5h10.667a.5.5 0 0 1 0 1H2.667a.5.5 0 0 1-.5-.5"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgEdit2;
